import { baseEnvironment, BackofficeEnvironment } from './environment.model';

export const environment: BackofficeEnvironment = {
  ...baseEnvironment,
  production: true,
  apiUrl: 'https://api-kariera.zabka.motivlab.io',
};
